module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    attrs: {
      "id": "login-box"
    }
  }, [_c('div', {
    staticClass: "bgshade-box",
    attrs: {
      "id": "login"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con-box"
  }, [_c('form', {
    staticClass: "form-box",
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.userLogin($event)
      }
    }
  }, [_c('p', {
    staticClass: "title-row"
  }, [_c('span', {
    staticClass: "login-tit"
  }, [_vm._v("登录")]), _vm._v(" "), _c('span', {
    staticClass: "login-close",
    on: {
      "click": _vm.closePopup
    }
  })]), _vm._v(" "), (_vm.userTips.loginResTips) ? _c('p', {
    staticClass: "info-row tips tipsTop"
  }, [_vm._v("\n          " + _vm._s(_vm.userTips.loginResTips) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "info-row"
  }, [_c('input', {
    staticClass: "input-text",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), (_vm.placeholder.loginUserID) ? _c('label', {
    staticClass: "simulate-placeholder",
    attrs: {
      "for": "loginUserID"
    },
    on: {
      "click": _vm.ie9hideInputID
    }
  }, [_vm._v("手机号 / 邮箱 / IP360账号")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVal.userIdVal),
      expression: "userVal.userIdVal"
    }],
    key: "user-login",
    ref: "userID",
    staticClass: "input-text",
    attrs: {
      "type": "text",
      "placeholder": "手机号 / 邮箱 / IP360账号",
      "id": "loginUserID"
    },
    domProps: {
      "value": (_vm.userVal.userIdVal)
    },
    on: {
      "blur": _vm.checkUser,
      "focus": _vm.ie9hideInputID,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userVal, "userIdVal", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.userTips.userIdTips) ? _c('p', {
    staticClass: "info-row tips"
  }, [_vm._v("\n          " + _vm._s(_vm.userTips.userIdTips) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "pwd-row info-row"
  }, [_c('input', {
    staticClass: "input-text",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "password"
    }
  }), _vm._v(" "), (_vm.placeholder.loginUserPW) ? _c('label', {
    staticClass: "simulate-placeholder",
    attrs: {
      "for": "loginUserPW"
    },
    on: {
      "click": _vm.ie9hideInputPW
    }
  }, [_vm._v("密码")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVal.userPwdVal),
      expression: "userVal.userPwdVal"
    }],
    key: "user-pwd",
    ref: "userPwd",
    staticClass: "input-text",
    attrs: {
      "type": "password",
      "placeholder": "密码",
      "id": "loginUserPW",
      "autocomplete": "false"
    },
    domProps: {
      "value": (_vm.userVal.userPwdVal)
    },
    on: {
      "blur": _vm.checkPwd,
      "focus": _vm.ie9hideInputPW,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userVal, "userPwdVal", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.hidepwd) ? _c('img', {
    attrs: {
      "src": require("../../assets/user/hidepwd.png")
    },
    on: {
      "click": _vm.pwdIsShow
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showpwd) ? _c('img', {
    attrs: {
      "src": require("../../assets/user/showpwd.png")
    },
    on: {
      "click": _vm.pwdIsShow
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.userTips.userPwdTips) ? _c('p', {
    staticClass: "info-row tips"
  }, [_vm._v("\n          " + _vm._s(_vm.userTips.userPwdTips) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.placeholder.loginUserSEC) ? _c('label', {
    staticClass: "simulate-placeholder",
    attrs: {
      "for": "loginUserSEC"
    },
    on: {
      "click": _vm.ie9hideInputSEC
    }
  }, [_vm._v("验证码")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVal.secVal),
      expression: "userVal.secVal"
    }],
    staticClass: "input-text input-code",
    attrs: {
      "type": "text",
      "placeholder": "验证码",
      "id": "loginUserSEC"
    },
    domProps: {
      "value": (_vm.userVal.secVal)
    },
    on: {
      "blur": _vm.checkSec,
      "focus": _vm.ie9hideInputSEC,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userVal, "secVal", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "input-text input-codebtn",
    attrs: {
      "src": _vm.vcodeUrl
    },
    on: {
      "click": _vm.getVcode
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info-row clearfix"
  }, [(_vm.userTips.userSecTips) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.userTips.userSecTips))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("忘记密码？")])])]), _vm._v(" "), _c('p', {
    staticClass: "submit-row"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.userLogin($event)
      },
      "click": _vm.userLogin
    }
  }, [_vm._v("登 录")])]), _vm._v(" "), _c('p', {
    staticClass: "no-userID"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.goRegister
    }
  }, [_vm._v("没有账号? 立即注册")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe8ec2bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Login.vue
// module id = 780
// module chunks = 1